import { MiscUtil } from '@/utils/miscUtil'

// 用户登录判断
export default {
    namespaced: true,
    state: {
        acUrl: '',
        username: '',
        userID: '',
        isLogged: false
    },
    mutations: {
        /**
         * 登录
         */
        login({ acUrl }) {
            if (acUrl) {
                MiscUtil.fetch('', {
                    baseURL: acUrl,
                    url: 'sys/login.htm',
                    method: 'post'
                }).then(data => {
                    window.location.href = data.object
                })
            } else {
                window.location.href = MiscUtil.getAppPath('user/login')
            }
        },
        /**
         * 注销
         */
        logout({ acUrl }) {
            if (acUrl) {
                window.location.href = acUrl + '/j_spring_security_logout'
            } else {
                window.location.href = MiscUtil.getAppPath('logout/cas')
            }
        }
    },
    actions: {
        /**
         * 检查用户登录状态
         */
        async checkUserState({ state, commit }) {
            // 获取应用中心地址
            return MiscUtil.fetch('config/getPropertyValueByKey', {
                method: 'post',
                params: { key: 'applicationCenter.url' }
            })
                .then(acUrl => {
                    // 应用中心地址
                    state.acUrl = acUrl.value

                    // 从应用中心获取用户登陆信息
                    return MiscUtil.fetch('', {
                        baseURL: acUrl.value,
                        url: 'user/getUserInfo',
                        method: 'post',
                        withCredentials: true
                    }).then(data => {
                        const { userName, userId } = data
                        state.username = String(userName)
                        state.userID = String(userId)
                        state.isLogged = !!userId
                        return true
                    })
                })
                .catch(() => {
                    // 从后台接口获取用户登陆信息
                    return MiscUtil.fetch('user/getUserInfo', {
                        method: 'get'
                    }).then(data => {
                        const { username, userID, enabled } = data
                        state.username = String(username)
                        state.userID = String(userID)
                        state.isLogged = Boolean(enabled)
                        return true
                    })
                })
                .finally(() => {
                    // 如果未登录 但是 存在已登录的相关信息 跳转到登陆界面
                    if (
                        !state.isLogged &&
                        MiscUtil.getParam('u') &&
                        MiscUtil.getParam('id')
                    ) {
                        commit('login')
                    }
                })
        }
    }
}
